import {HttpModelConverter} from "../../../../core/converter/httpModel.converter";
import {TagSummaryModel} from "./tagSummary.model";
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class TagSummaryConverter extends HttpModelConverter<TagSummaryModel> {
    protected createInstance(): TagSummaryModel {
        return new TagSummaryModel();
    }

    protected enrichObject(result: TagSummaryModel, src: TagSummaryModel) {
    }

}